import { useEffect } from 'react'
import { useClikArtPlacedIdsQuery } from '@/api/hooks/use-clikart-placed-ids'
import { seedClikArtPlacementsFromServer } from '@/lib/clikart/clikart-placement-session'

/**
 * Keeps the session's ClikArt placements in step with the backend's scan of the book: every time
 * the placed-ids query has data, a scan that has finished at least once is applied (the spreads
 * the live canvas has opened keep their own data — see `seedClikArtPlacementsFromServer`).
 *
 * A book that has never been scanned reads as "nothing placed" in the response, which is not
 * something to believe, so it is skipped and the gallery keeps the catalog's flag until a scan
 * lands.
 */
export function useClikArtPlacedIdsSync(enabled: boolean) {
  const { data } = useClikArtPlacedIdsQuery(enabled)

  useEffect(() => {
    if (!data?.hasScanned) return

    seedClikArtPlacementsFromServer(data.placedBySpread)
  }, [data])
}
